import { render, staticRenderFns } from "./ClientsBlock.vue?vue&type=template&id=44bb510b&"
import script from "./ClientsBlock.vue?vue&type=script&lang=js&"
export * from "./ClientsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ClientsBlock.vue?vue&type=style&index=0&id=44bb510b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports